import { SponsorBody, SponsorResponse } from '../../../../API';
import { useSponsorsAPI } from '../../../../hooks/API/Payments/useSponsorsAPI';
import { CreateDataManager, DataManagerHookReturnType, DataManagerStateFullReturnType } from '../../../DataManager';

export type SponsorsDataManagerType = {
  state: DataManagerStateFullReturnType<SponsorResponse, SponsorBody>;
  hook: DataManagerHookReturnType<SponsorResponse, SponsorBody>;
};

const generateNew = (): SponsorBody => ({
  name: '',
  slogan: '',
  logo: '',
  website: ''
});

export const SponsorsDataManager = CreateDataManager<SponsorResponse, SponsorBody>({
  name: 'sponsors',
  idField: 'id',
  isVersionedEntity: false,
  useApiHook: useSponsorsAPI,
  generateNew,
  useUpdateForCreate: true,
  toString: (sponsor: SponsorBody | SponsorResponse) => sponsor.name
});
